import {
  ActiveTaskTimeLogModel,
  TaskTimeLogModel,
} from "@jugl-web/rest-api/tasks/models/TaskTimeLog/TaskTimeLogModel";
import { createContext } from "react";

export interface ActiveTimeTrackingContextValue {
  activeTimeLog: ActiveTaskTimeLogModel | null;
  isLoading: boolean;
  startTimer: (taskId: string) => Promise<TaskTimeLogModel | null>;
  stopActiveTimer: () => Promise<TaskTimeLogModel | null>;
  refetchActiveTimeLog: () => Promise<ActiveTaskTimeLogModel | null>;
}

export const ActiveTimeTrackingContext =
  createContext<ActiveTimeTrackingContextValue | null>(null);
